Revolution.Module.extend({
    NAME: "mde.nav", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        _.bindAll(this, "showBtnExpendTouch");
        //
        this.initEnquireResetStyles();

        //events


        //Open submenu headerSup
        $('body').on('click', '.js-toggle-sub-menu', this.toggleSubMenu);
        $('body').on('click', '.js-close-sub-menu', this.closeSubMenus);
        $('body').click(this.closeSubMenus);

        $('body').on('click', '.js-toggle-sub-menu, .sub-menu', function(e) {
            e.stopPropagation();
        });


        $('.js-toggle-mob-nav').on('click', this.toggleMobileMenu);
        $('.wrapper-menu').keydown(this.tabInLayer);

        $('.wrapper-menu .li-level-1 .js-close-sub-menu').on('click', this.navCloseDesktop);

        $('.wrapper-menu .li-level-1 > button').on('click', this.toggleLevel2);

        $('.page-footer-wrapper .menu>li>button').on('click', this.footerNav);

        if (Modernizr.touchevents) {
            this.showBtnExpendTouch();
        }

        this.headerSticky();

    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
    },

    tabInLayer: function (e) {
        var $obj = $(e.currentTarget);
        if($('.btn-nav-mob').is(':visible')) {
            var ACCESS = Revolution.get("mde.accessible-function");
            ACCESS.trapTabKey($obj, e);
            ACCESS.trapEscapeKey($obj, e);
        }
    },

    closeSubMenus: function(e) {
        $('body').css('overflow', '');
        if($('.btn-nav-mob').is(':visible')) {
            $('.sub-menu:not(.search):visible').slideUp().prev('.js-toggle-sub-menu').removeClass('active').attr('aria-expanded', "false");
        } else {
            $('.sub-menu:visible').slideUp().prev('.js-toggle-sub-menu').removeClass('active').attr('aria-expanded', "false");
        }
    },

    toggleSubMenu: function (e) {
        var $obj = $(e.currentTarget);
        var $subMenu = $obj.next('.sub-menu');
        if (!$obj.hasClass('active')) {
            if(!$('.btn-nav-mob').is(':visible')) {
                $('.page-header-wrapper .sub-menu:visible').hide();
            }
            $subMenu.slideDown();
            $('body').css('overflow', 'hidden');
            $obj.addClass('active').attr('aria-expanded', 'true');
        } else {
            $subMenu.slideUp();
            $('body').css('overflow', '');
            $obj.removeClass('active').attr('aria-expanded', 'false');
        }
    },

    navCloseDesktop: function (e) {
        $obj.closest('.li-level-1').removeClass('active');
        var UTILS = Revolution.get("mde._utils");
        $obj = $(e.currentTarget);
        if (UTILS.isMenuDesktop()) {
            $obj.closest('.level-2-wrapper').removeClass('open').stop().fadeOut();
        }
    },

    reinitMobileMenu: function () {
        $('body, header [style]').removeAttr('style');
        $('header .open').removeClass('open');
    },

    initEnquireResetStyles: function () {
        enquire.register("screen and (max-width:63.9375em)", { //1024px
            match: _.bind(function () {
                this.reinitMobileMenu();
                this.loadMobileMenu();
                $('.page-footer-wrapper .menu>li>button').attr('aria-expanded', 'false');
                $('.sub-menu.search').insertBefore('.header-sup');
            }, this),
            unmatch: _.bind(function () {
                this.reinitMobileMenu();
                this.loadDesktopMenu();
                $('.page-footer-wrapper .menu>li>button').attr('aria-expanded', 'true');
                $('.sub-menu.search').insertAfter('.header-bottom .js-toggle-sub-menu');
            }, this)
        });
    },

    toggleMobileMenu: function (e) {
        e.preventDefault();
        $obj = $(e.currentTarget);
        $mobileNav = $('.wrapper-menu');

        if ($obj.hasClass('open')) {
            if($obj.hasClass('return')) {
                $obj.removeClass('return');
                $('.wrapper-menu .li-level-1 > button').attr('aria-expanded', 'false');
                $('.wrapper-menu .li-level-1').removeClass('open');
                $('.wrapper-menu .level-2-wrapper').removeClass('open');
            } else {
                $obj.removeClass('open').attr('aria-expanded', 'false');
                $mobileNav.stop().fadeOut();
                $('body').css('overflow', '');
                $('body').removeClass('nav-mob-is-open');
            }
        } else {
            $obj.addClass('open').attr('aria-expanded', 'true');
            $mobileNav.stop().fadeIn();
            $('body').css('overflow', 'hidden');
            $('body').addClass('nav-mob-is-open');
        }
    },

    toggleLevel2: function (e) {
        e.preventDefault();
        $obj = $(e.currentTarget);
        $currentLi = $obj.closest('li');
        $currentLevel2 = $currentLi.find('.level-2-wrapper');
        $mobileNav = $('.wrapper-menu');
        var UTILS = Revolution.get("mde._utils");

        if (UTILS.isMenuMobile()) { //MOBILE
            if ($currentLi.hasClass('open')) { // BACK TO LEVEL 1
                $('.js-toggle-mob-nav').removeClass('return');
                $obj.attr('aria-expanded', 'false');
                $currentLi.removeClass('open');
                $currentLevel2.stop().removeClass('open');
            } else { // GO TO LEVEL 2
                $('.js-toggle-mob-nav').addClass('return');
                $obj.attr('aria-expanded', 'true');
                $currentLi.addClass('open');
                $currentLevel2.stop().addClass('open');
            }
        } else { //DESKTOP & TOUCH
            if ($currentLevel2.hasClass('open')) { //close
                $obj.attr('aria-expanded', 'false');
                $currentLi.removeClass('active');
                $currentLi.find('.level-2-wrapper').removeClass('open').stop().fadeOut();
            } else {// open
                //close opened nav
                $mobileNav.find('> button').attr('aria-expanded', 'false');
                $mobileNav.find('.active').removeClass('active');
                $mobileNav.find('.open').removeClass('open');
                $mobileNav.find('.level-2-wrapper').stop().fadeOut();

                //open current
                $obj.attr('aria-expanded', 'true');
                $currentLi.addClass('active');
                $currentLi.find('.level-2-wrapper').addClass('open').stop().fadeIn();

            }
        }

    },

    showBtnExpendTouch: function () {
        $('.page-header-wrapper .wrapper-menu .li-level-1 .btn-expend').show();
    },

    headerSticky : function() {
        $('header').headroom();
    },

    loadMobileMenu: function() {
        $('.wrapper-menu .ul-wrapper').append($('.header-top .lists-wrapper'));
    },

    loadDesktopMenu: function() {
        $('.header-top .site-content').append($('.wrapper-menu .lists-wrapper'));
    },

    footerNav : function(e) {
        e.preventDefault();
        $obj = $(e.currentTarget);

        enquire.register("screen and (max-width:47.9375em)", { //767px
            match: _.bind(function () {
                if($obj.hasClass('open')) {
                    $obj.removeClass('open').attr('aria-expanded', 'false');
                    $obj.next('ul').stop().slideUp();
                } else {
                    $('.page-footer-wrapper .menu>li>button').removeClass('open').attr('aria-expanded', 'false');
                    $('.page-footer-wrapper .menu>li ul').stop().slideUp();
                    $obj.addClass('open').attr('aria-expanded', 'true');
                    $obj.next('ul').stop().slideDown();
                }
            }, this),
            unmatch: _.bind(function () {
                $('footer nav .menu>li>ul').show();
                $('footer nav .menu>li>ul').css('height', 'auto');
            }, this),
        });

        if($('header .btn-nav-mob').is(':visible')) {
        }
    }


});
